export const DEFAULT: string = "default";
export const VO: string = "vo";
export const SFX: string = "sfx";
export const BGM: string = "bgm";
